import { Slot, type SlotReadyEvent } from "./events/SlotReadyEvent";

function isUndefinedOrUUID(value: string | undefined | null): boolean {
	if (value === undefined || value === null) {
		return true;
	}

	const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	return uuidRegex.test(value);
}

function handleSlotReady(event: SlotReadyEvent): void {
	switch (event.slotId) {
		case Slot.BOUNCE_LAYER: {
			event.targetElement.innerHTML = `<ft9-bounce-v1 variation-id="${event.variationId}"></ft9-bounce-v1>`;
			break;
		}
		case Slot.PARTNER_BENEFIT: {
			const searchParams = new URLSearchParams(window.location.search);
			const autoActivateBenefitId = searchParams.get("benefitId")?.replaceAll("/", "").replaceAll("%2F", "").trim();

			if (!isUndefinedOrUUID(autoActivateBenefitId)) {
				throw new Error(`Invalid benefitId: ${autoActivateBenefitId}`);
			}

			event.targetElement.innerHTML = `<ft9-detailview-v1 team="ft5" feature="pdpDetailview" variation-id="${event.variationId}" product-id="${event.productId}" ${autoActivateBenefitId ? `benefit-id="${autoActivateBenefitId}"` : ""} ${event.eventMergeId ? `event-merge-id="${event.eventMergeId}"` : ""}></ft9-detailview-v1>`;
			break;
		}
	}
}

export function initSlotReadyListener(): void {
	window.o_global.eventQBus.on("ft9.benefit.slotReady", handleSlotReady);
}
